<template>
  <component
    :is="tag"
    v-bind="attributes"
    ref="el"
    class="c-fade-in"
    :class="{ isShow }"
    ><slot
  /></component>
</template>

<script>
export default {
  name: 'ComponentsFadeIn',
  props: {
    delay: {
      type: Number,
      default: 0,
    },
    tag: {
      type: String,
      default: 'div',
    },
    attributes: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      isShow: false,
    }
  },
  mounted() {
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            this.isShow = true
          }, 500 + this.delay)
          observer.disconnect()
        }
      })
    })

    observer.observe(this.$refs.el)
  },
}
</script>

<style lang="scss" scoped>
.c-fade-in {
  opacity: 0;
  transform: translateY(20px);
  transition: 0.5s ease-in-out;

  &.isShow {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
